export const projectsData = [
  {
    id: "alok-home-ranchi",
    title: "Alok Home Interior",
    location: "Ranchi",
    category: "Residential",
    description:
      "Complete home interior project including living room, modular kitchen, bedroom design and custom furniture.",
    images: [
      require("../assets/projects/alok-home/1.jpeg"),
      require("../assets/projects/alok-home/2.jpeg"),
      require("../assets/projects/alok-home/3.jpeg"),
      require("../assets/projects/alok-home/4.jpeg"),
    ],
    layouts: [
      {
        type: "2BHK",
        name: "Ground Floor Layout",
        pdf: "/layouts/alok-home/layout1.pdf",
      },
      {
        type: "3BHK",
        name: "Complete Floor Plan",
        pdf: "/layouts/alok-home/layout2.pdf",
      },
    ],
  },
  {
    id: "purwanchal-noida",
    title: "Purwanchal Apartment",
    location: "Greater Noida",
    category: "Residential",
    description:
      "Luxury apartment interior design with designer ceiling, modular kitchen, wardrobe and lighting design.",
    images: [
      require("../assets/projects/purwanchal-noida/1.jpeg"),
      require("../assets/projects/purwanchal-noida/2.jpeg"),
      require("../assets/projects/purwanchal-noida/3.jpeg"),
      require("../assets/projects/purwanchal-noida/4.jpeg"),
      require("../assets/projects/purwanchal-noida/5.jpeg"),
      require("../assets/projects/purwanchal-noida/6.jpeg"),
    ],
     layouts: [
      {
        type: "2BHK",
        name: "Ground Floor Layout",
        pdf: "/layouts/alok-home/layout1.pdf",
      },
      {
        type: "3BHK",
        name: "Complete Floor Plan",
        pdf: "/layouts/alok-home/layout2.pdf",
      },
    ],
  },
  {
  id: "odisha-house",
  title: "Odisha House",
  location: "Odisha",
  category: "Residential",
  description:
    "Elegant residential interior design project featuring modern layouts, custom furniture, premium finishes, and smart lighting solutions tailored for a comfortable lifestyle.",

  images: [
    require("../assets/projects/odisha-home/1.jpeg"),
    // require("../assets/projects/odisha-house/2.jpeg"),
    // require("../assets/projects/odisha-house/3.jpeg"),
    // require("../assets/projects/odisha-house/4.jpeg"),
    // require("../assets/projects/odisha-house/5.jpeg"),
    // require("../assets/projects/odisha-house/6.jpeg"),
  ],

  layouts: [
    {
      type: "2BHK",
      name: "Ground Floor Layout",
      pdf: "/layouts/odisha-house/layout1.pdf",
    },
    {
      type: "3BHK",
      name: "Complete Floor Plan",
      pdf: "/layouts/odisha-house/layout2.pdf",
    },
  ],
}
];